export default __webpack_public_path__ + "static/media/imageSize.d3a2833e.svg";